export const GOAL_TARGET_PROPERTIES = {
  HS_KPI_VALUE: 'hs_kpi_value',
  HS_TARGET_AMOUNT: 'hs_target_amount',
  HS_KPI_UNIT_TYPE: 'hs_kpi_unit_type'
};
export const GOAL_TARGET_PROPERTIES_DEPENDENT_ON_KPI_UNIT_TYPE = [GOAL_TARGET_PROPERTIES.HS_TARGET_AMOUNT, GOAL_TARGET_PROPERTIES.HS_KPI_VALUE];